<template>
  <div>
    <div class="row">
      <div class="form-group col-md-12 text-left">
        <label for="categoryName">{{ $t('row_categories.name') }}</label>
        <input
          type="text"
          class="form-control"
          :placeholder="$t('row_categories.name')"
          id="categoryName"
          v-model="categoryName"
        />
        <p v-if="categoryNameEmpty" class="error" data-test="empty_name_error">
          {{ $t('row_categories.name_empty') }}
        </p>
      </div>
    </div>
    <div class="row">
      <div class="form-group">
        <div class="col-md-6 text-left">
          <button
            id="backToList"
            class="btn btn-default"
            @click="backToList({})"
          >
            {{ $t('row_categories.back') }}
          </button>
        </div>
        <div class="col-md-6 text-right">
          <button
            v-if="categoryToEdit"
            id="saveAsNewBtn"
            class="spaced btn btn-primary"
            @click="persistCategory(true)"
          >
            {{ $t('row_categories.save_as_new') }}
          </button>
          <button
            id="saveBtn"
            class="btn btn-primary"
            @click="persistCategory(false)"
          >
            {{ $t('row_categories.save') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapState} from 'vuex';

const validate = categoryName => {
  let categoryNameEmpty = false;

  let pass = true;
  if (categoryName === undefined || categoryName.trim() === '') {
    pass = false;
    categoryNameEmpty = true;
  }

  return {pass, categoryNameEmpty};
};

export default {
  name: 'RowCategoriesForm',
  computed: mapState({
    categoryToEdit: state => state.rowCategoriesModule.categoryToEdit,
    error: state => state.error
  }),
  created: function () {
    if (this.categoryToEdit) {
      this.categoryName = this.categoryToEdit.name;
    }
  },
  methods: {
    ...mapActions('rowCategoriesModule', [
      'backToList',
      'saveRowCategory',
      'updateRowCategory'
    ]),
    persistCategory(saveAsNew) {
      const validation = validate(this.categoryName);
      this.categoryNameEmpty = validation.categoryNameEmpty;

      if (validation.pass) {
        if (saveAsNew || !this.categoryToEdit) {
          this.saveRowCategory({name: this.categoryName}).then(
            function () {
              if (this.error === undefined) {
                this.backToList({reloadCategories: true});
              }
            }.bind(this)
          );
        } else {
          this.updateRowCategory({
            categoryId: this.categoryToEdit.id,
            category: {id: this.categoryToEdit.id, name: this.categoryName}
          }).then(
            function () {
              if (this.error === undefined) {
                this.backToList({reloadCategories: true});
              }
            }.bind(this)
          );
        }
      }
    }
  },
  data: function () {
    return {
      categoryName: '',
      categoryNameEmpty: false
    };
  }
};
</script>

<style scoped>
.spaced {
  margin-right: 1em;
}

.error {
  color: red;
}
</style>
